module.exports = __webpack_public_path__ + "1_0_59/img/assign-close.ff5e876b.svg";